import { Injectable, ViewContainerRef } from '@angular/core';
import { injectLazy } from 'ngxtension/inject-lazy';

import type { NotificationService as KendoNotificationService, Position } from '@progress/kendo-angular-notification';
import {
  ErrorNotificationComponent,
  ReservedNotificationComponent,
  SuccessNotificationComponent,
} from '@assist/notifications/ui';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly defaultPosition: Position = { horizontal: 'right', vertical: 'bottom' };

  #kendoNotificationService = injectLazy(
    () => import('@progress/kendo-angular-notification').then((m) => m.NotificationService) as any
  );

  reserved(id: string, subject: string, email: string, position: Position = this.defaultPosition): void {
    this.#kendoNotificationService.subscribe((s) => {
      const service = s as KendoNotificationService;
      const ref = service.show({
        content: ReservedNotificationComponent,
        hideAfter: 4000,
        position,
        animation: { type: 'fade', duration: 400 },
      });

      ref.content.setInput('id', id);
      ref.content.setInput('subject', subject);
      ref.content.setInput('email', email);
    });
  }

  success(
    title: string,
    message: string,
    appendTo?: ViewContainerRef,
    position: Position = this.defaultPosition
  ): void {
    this.#kendoNotificationService.subscribe((s) => {
      const service = s as KendoNotificationService;
      const ref = service.show({
        content: SuccessNotificationComponent,
        hideAfter: 4000,
        appendTo: appendTo,
        position,
        animation: { type: 'fade', duration: 400 },
      });

      ref.content.setInput('title', title);
      ref.content.setInput('text', message);
    });
  }

  error(title: string, message: string, appendTo?: ViewContainerRef, position: Position = this.defaultPosition): void {
    this.#kendoNotificationService.subscribe((s) => {
      const service = s as KendoNotificationService;
      const ref = service.show({
        content: ErrorNotificationComponent,
        hideAfter: 4000,
        appendTo: appendTo,
        position,
        animation: { type: 'fade', duration: 400 },
      });

      ref.content.setInput('title', title);
      ref.content.setInput('text', message);
    });
  }
}
